import React from 'react';
import { MyPortfolioCapsuleContentProps } from 'widgets/myPortfolioCapsules/MyPortfolioCapsuleWidgetStrategy';
import { useMyPortfolioCapsuleConfigSlice } from 'widgets/myPortfolioCapsules/store/config/configSlice';
import { useWidgetContext } from 'widgets/WidgetContext';
import { ObvTileConfigState } from 'widgets/obvTile/store/config/ObvTileConfigState';
import { buildObvTileData } from 'widgets/obvTile/obvTileData';
import { ObvTileContent } from 'widgets/obvTile/components/ObvTileContent';
import { obvStreamedDataSelectors } from 'widgets/obvTile/store/stream/streamSlice';

const { useSymbolStreamedData } = obvStreamedDataSelectors;

export function ObvTileMyPortfolioCapsuleContent(
    props: MyPortfolioCapsuleContentProps
) {
    const { symbol } = props;
    const { config } = useMyPortfolioCapsuleConfigSlice<ObvTileConfigState>();
    const { widgetKey } = useWidgetContext();

    const { bucketSize, showDataFor } = config;

    const streamData = useSymbolStreamedData(symbol, config);
    const data = buildObvTileData(bucketSize, streamData, showDataFor);

    return <ObvTileContent data={data} capsuleKey={`${widgetKey}=${symbol}`} />;
}
